// assets
import BankOutlined from '@ant-design/icons/BankOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import PercentageOutlined from '@ant-design/icons/PercentageOutlined';

// icons
const icons = { BankOutlined, UserOutlined, PercentageOutlined };

// ==============================|| MENU ITEMS - CENTRES ||============================== //

const centres = {
  id: 'centres',
  title: 'Centres',
  type: 'collapse',
  url: '/centres', // Add URL for clickable behavior
  icon: icons.BankOutlined,
  permission: {
    module: 'centres',
    level: 10 // View permission required
  },
  children: [
    {
      id: 'dentists',
      title: 'Dentists',
      type: 'item',
      url: '/dentists',
      icon: icons.UserOutlined,
      permission: {
        module: 'dentists',
        level: 10 // View permission required
      }
    },
    {
      id: 'centres-splits',
      title: 'GPSP Splits',
      type: 'item',
      url: '/centres/splits',
      icon: icons.PercentageOutlined,
      permission: {
        module: 'centres',
        level: 10
      }
    }
  ]
};

export default centres;
